import React from 'react';

import { Container } from './styles';

interface Props {
  children: React.ReactNode;
}

const DisabledFeature: React.FC<Props> = ({ children }: Props) => {
  return (
    <Container>
      {children}
      <span className="message">
        🚫 This feature is not enabled right now 🙂
      </span>
    </Container>
  );
};

export default DisabledFeature;
